import * as types from '../actionTypes/App'
import { updateObject } from '../utility'

const initialState = {
    environment: null,
}

const updateEnvironment = (state, action) => {
    return updateObject(state, {
        environment: action.value,
    })
}

const AppReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_ENVIRONMENT:
            return updateEnvironment(state, action)

        default:
            return state
    }
}

export default AppReducer
